/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2TaskOtherBoardsIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2TaskOtherBoardsIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2TaskOtherBoardsIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2TaskOtherBoardsIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 14"
 style={{'--as-1-25DXKk': alignSelf,'--mt-2-25DXKk': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-25DXKk': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-25DXKk': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-25DXKk': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-25DXKk': opacity,'--w-10-25DXKk': typeof width === 'number' ? `${width}px` : width,'--h-11-25DXKk': typeof height === 'number' ? `${height}px` : height,'--f-12-25DXKk': fill,'--a-7-25DXKk': isAnimated ? animation : "none",'--sd-8-25DXKk': isAnimated ? strokeDashoffset : 0,'--sd-9-25DXKk': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2TaskOtherBoardsIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.25 0a1 1 0 00-1 1v.5a1 1 0 001 1h3a1 1 0 001-1V1a1 1 0 00-1-1h-3zM1.5 1H2v.5a2.25 2.25 0 002.25 2.25h3A2.25 2.25 0 009.5 1.5V1h.5a1.5 1.5 0 011.5 1.5v10A1.5 1.5 0 0110 14H1.5A1.5 1.5 0 010 12.5v-10A1.5 1.5 0 011.5 1zm2.78 4.97a.75.75 0 00-1.06 1.06L4.69 8.5 3.22 9.97a.75.75 0 101.06 1.06l1.47-1.469 1.47 1.47a.75.75 0 101.06-1.06L6.81 8.5l1.47-1.47a.75.75 0 00-1.06-1.06L5.75 7.44 4.28 5.97z"
 style={{'--f-12-25DXKk': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}